import React from "react";
import contextProvider from "../../../contextProvider";
import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { withRouter } from "react-router-dom";
import { Row, Col, Collapse } from "reactstrap";
import ReactOButton from "../../../_L1_components/Elements/ReactOButton";
import ReactOTooltip from "../../../_L1_components/Elements/ReactOTooltip";
import StepCard from "../../Elements/StepCard";
import Panel from "../../../_L1_components/Layout/Panel";

class GridView extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      collapse: false,
      data: {},
      initOpen: null,
      content: "",
      gridBox: null,
      id2: null,
      nextOpen: null,
    };
    super(props, initState);
  }

  verifyGrid(width) {
    return width >= 1500 ? 3 : width < 1500 && width > 900 ? 2 : 1;
  }

  formatMBytes(val) {
    parseFloat(val);
    let number = val / 1000000;
    return Math.round((number + Number.EPSILON) * 100) / 100;
  }

  formatGrid() {
    this.setState({ collapse: false }, () => {
      this.currentGridView = 0;
      let rawDataToGrid = [];
      let gridBox = {};
      let rowElement = [];
      let initOpen = false;
      let collapse;
      let content;
      let totalStep;
      this.props.listData.summary.steps.forEach((_CURR_phase, _CURR_idx) => {
        let numStep = 0;
        let _TMP_filtered = [];
        if (_CURR_phase[1] != "nan") {
          _TMP_filtered = this.props.listData.steps.filter((value) => {
            let re = new RegExp(
              "(^" + _CURR_phase[0] + "$)|(^" + _CURR_phase[0] + "\\s\\-\\s.*$)"
            );
            return re.test(value.name);
          });
        }
        totalStep = _TMP_filtered.length;

        if (
          _TMP_filtered.length > 1 &&
          _TMP_filtered[0].name != _CURR_phase[0]
        ) {
          _TMP_filtered.unshift({
            name: _CURR_phase[0],
            heading: true,
            result: "_HEADING_",
          });
        }
        (_TMP_filtered.length
          ? _TMP_filtered
          : [{ name: _CURR_phase[0] }]
        ).forEach((_C_detail_step, _C_detail_idx, array) => {
          let detailPhase = { ..._C_detail_step };

          // CHECK 'DISCONNECTED BY AP'
          if (this.props.listData.summary.discearly == _CURR_phase[0]) {
            detailPhase.extraInfo = "Early disconnected by AP";
            detailPhase.discearly = true;
          }

          detailPhase.summary = _CURR_phase;
          if (_C_detail_idx == 0) {
            detailPhase.info = true;
          }
          if (array.length > 1) {
            _C_detail_step.result != "_HEADING_" && numStep++;
            let rawNaming = detailPhase.name.split(/\s*\-\s*/g);
            detailPhase.subStep = {
              name: rawNaming[0], // + " " + (_C_detail_idx + 1) + "/" + array.length,
              subName: rawNaming.length > 1 ? rawNaming[1] : "",
              numStep: _C_detail_step.result != "_HEADING_" ? numStep : null,
              totalStep: totalStep,
            };
          }
          if (array.length - 1 == _C_detail_idx) {
            detailPhase.lastElem = true; // check for initOpen in multiple err
          }

          // CHECK EXECUTED STEP

          if (
            detailPhase.harid ||
            detailPhase.jpegid ||
            (detailPhase.result && /^TIME FROM:/gm.test(detailPhase.result))
          ) {
            let _TMP_split = detailPhase.result.split("|");
            _TMP_split.forEach((_C_data) => {
              let _TMP_regex_res = /^\s*TIME:\s(.*)\s*$/.exec(_C_data);

              if (_TMP_regex_res) {
                if (Number.isInteger(parseInt(_TMP_regex_res[1]))) {
                  detailPhase.execStep = true;
                }
              }
            });
          }

          rawDataToGrid.push(detailPhase);
        });
      });

      rawDataToGrid.push({
        name: "END OF MEASURE",
        result: this.props.listData.end
          ? this.props.listData.end
          : "No details available",
        summary: ["END OF MEASURE", ""],
        end: true,
      });

      this._rawDataToGrid = rawDataToGrid;
      rawDataToGrid.sort().forEach((_C_detail_step, id) => {
        let card_id =
          _C_detail_step.name.replace(/[^A-Z0-9]/gi, "").toLowerCase() +
          "_" +
          id;
        _C_detail_step.card_id = card_id;
        rowElement.push(_C_detail_step);
        if (id % 3 == 2) {
          gridBox = { ...gridBox, [id]: rowElement };
          rowElement = [];
        }
        if (
          _C_detail_step.summary &&
          _C_detail_step.summary[1] &&
          _C_detail_step.summary[1] != "nan" &&
          _C_detail_step.result &&
          _C_detail_step.result != "_HEADING_" &&
          !_C_detail_step.discearly &&
          _C_detail_step.lastElem &&
          !/^(\d+)$/.test(_C_detail_step.summary[1]) &&
          !initOpen
        ) {
          initOpen = true;
          collapse = card_id;
          content = _C_detail_step;
        }
      });

      if (rowElement.length > 0) {
        gridBox = {
          ...gridBox,
          [this.props.listData.summary.steps.length + 10]: rowElement,
        };
      }

      if (initOpen) {
        this.setState({
          gridBox: gridBox,
          collapse: collapse,
          content: content,
        });
      } else {
        this.setState({
          gridBox: gridBox,
        });
      }
    });
  }

  onComponentDidMount() {
    // console.log("props gridView", this.props);
    this.props.innerRef.current = this;
    this.formatGrid();
  }

  componentWillUnmount() {
    this.props.innerRef.current = null;
  }

  onRender() {
    let rowElement = [];
    let initOpen = false;

    if (
      this._rawDataToGrid != undefined &&
      this.currentGridView != this.verifyGrid(window.innerWidth)
    ) {
      this.gridBox = {};
      if (window.innerWidth >= 1500) {
        this.currentGridView = 3;
      } else if (window.innerWidth < 1500 && window.innerWidth > 900) {
        this.currentGridView = 2;
      } else if (window.innerWidth <= 900) {
        this.currentGridView = 1;
      }
      this._rawDataToGrid.sort().forEach((_C_detail_step, id) => {
        rowElement.push(_C_detail_step);

        if (
          (window.innerWidth >= 1500 && id % 3 == 2) ||
          (window.innerWidth < 1500 &&
            window.innerWidth > 900 &&
            id % 2 == 1) ||
          (window.innerWidth <= 900 && id % 1 == 0)
        ) {
          this.gridBox = { ...this.gridBox, [id]: rowElement };
          rowElement = [];
        }

        if (
          _C_detail_step.summary &&
          _C_detail_step.summary[1] &&
          _C_detail_step.result &&
          _C_detail_step.result != "_HEADING_" &&
          _C_detail_step.lastElem &&
          !_C_detail_step.discearly &&
          !/^(\d+)$/.test(_C_detail_step.summary[1]) &&
          !initOpen
        ) {
          initOpen = true;
        }
      });

      if (rowElement.length > 0) {
        this.gridBox = {
          ...this.gridBox,
          [this.props.listData.summary.steps.length + 10]: rowElement,
        };
      }
    }

    return (
      <div style={{ backgroundColor: "white" }}>
        {this.gridBox != null && (
          <div className="mx-4">
            {Object.keys(this.gridBox).map((row, id) => {
              return (
                <div key={id}>
                  <Row key={id}>
                    {this.gridBox[row].map((col, id2) => {
                      return (
                        <Col
                          id={"tp_" + col.card_id}
                          xs={
                            (window.innerWidth > 1500 && 4) ||
                            (window.innerWidth < 1500 &&
                              window.innerWidth > 900 &&
                              6) ||
                            (window.innerWidth < 900 && 12)
                          }
                          className="my-2 px-2"
                          style={
                            col.result &&
                            col.result != "_HEADING_" &&
                            !col.discearly
                              ? { cursor: "pointer" }
                              : {}
                          }
                          onClick={
                            col.result &&
                            col.result != "_HEADING_" &&
                            !col.discearly
                              ? () => {
                                  if (!this.state.collapse) {
                                    this.setState({
                                      collapse: col.card_id,
                                      id2: id2,
                                      card_id: col.card_id,
                                      content: col,
                                    });
                                  } else if (
                                    this.state.collapse != col.card_id
                                  ) {
                                    this.setState({
                                      collapse: false,
                                      nextOpen: {
                                        collapse: col.card_id,
                                        id2: id2,
                                        card_id: col.card_id,
                                        content: col,
                                      },
                                    });
                                  } else if (
                                    this.state.collapse == col.card_id
                                  ) {
                                    this.setState({
                                      collapse: false,
                                      nextOpen: null,
                                    });
                                  }
                                }
                              : null
                          }
                          key={id2}
                        >
                          {col.summary[1] == "nan" && (
                            <ReactOTooltip
                              placement="bottom"
                              target={"tp_" + col.card_id}
                              text="Step not configured to run in this instant"
                              delay={{ show: 180 }}
                            />
                          )}
                          <StepCard
                            box_data={col}
                            selectedResult={this.props.selectedResult}
                            res_id={
                              this.props.listData.res_id
                                ? this.props.listData.res_id
                                : null
                            }
                            bssid={this.props.listData.bssid}
                            card_id={col.card_id}
                            collapse={this.state.collapse}
                            viewHar={this.props.viewHar.bind(this)}
                            viewLogcat={this.props.viewLogcat.bind(this)}
                            viewStep={this.props.viewStep.bind(this)}
                            _overlap_modal_video={
                              this.props._overlap_modal_video
                            }
                            _overlap_modal_screen={
                              this.props._overlap_modal_screen
                            }
                          />
                        </Col>
                      );
                    })}
                  </Row>
                  <Row>
                    <Col className="paddingTen">
                      <Collapse
                        isOpen={this.gridBox[row].some((elem) => {
                          return elem.card_id == this.state.collapse;
                        })}
                        onExited={() => {
                          if (this.state.nextOpen != null) {
                            this.setState({
                              collapse: this.state.nextOpen.collapse,
                              id2: this.state.nextOpen.id2,
                              card_id: this.state.nextOpen.card_id,
                              content: this.state.nextOpen.content,
                            });
                          }
                        }}
                      >
                        {(() => {
                          // console.log("state", this.state);
                          let _TMP_step_result = this.state.content.result;
                          let isChromium = false;
                          let chromiumInfo = [];
                          let chromiumTimeFrom = "";
                          let chromiumTimeTo = "";
                          let chromiumTime = "";
                          let chromiumSize = "";
                          let chromiumMsg = "";
                          let chromiumError = "";
                          let chromiumExtraInfo = "";
                          let chromiumBytesIn = "";
                          let chromiumBytesOut = "";
                          let chromiumHar = null;
                          let chromiumLogcat = null;
                          let chromiumJpeg = null;
                          let chromiumVideo = null;
                          let chromiumPDF = null;
                          let lmp4URL = undefined;
                          let chromiumLmp4;

                          if (
                            this.state.content.jpegid ||
                            /^TIME FROM:/gm.test(this.state.content.result)
                          ) {
                            isChromium = true;
                            let _TMP_split =
                              this.state.content.result.split("|");
                            let _REGEXs = [
                              {
                                name: "TIME FROM",
                                regex: /^\s*TIME\sFROM:\s(.*)\s*$/,
                              },
                              {
                                name: "TIME TO",
                                regex: /^\s*TIME\sTO:\s(.*)\s*$/,
                              },
                              {
                                name: "TIME",
                                regex: /^\s*TIME:\s(.*)\s*$/,
                              },
                              {
                                name: "SIZE",
                                regex: /^\s*SIZE:\s(.*)\s*$/,
                              },
                              {
                                name: "MSG",
                                regex: /^\s*MSG:\s(.*)\s*$/,
                              },
                              {
                                name: "ERROR",
                                regex: /^\s*ERROR:\s(.*)\s*$/,
                              },
                              {
                                name: "BYTESIN",
                                regex: /^\s*BYTESIN:\s(.*)\s*$/,
                              },
                              {
                                name: "BYTESOUT",
                                regex: /^\s*BYTESOUT:\s(.*)\s*$/,
                              },
                            ];
                            _TMP_split.forEach((_C_data) => {
                              _REGEXs.every((_C_regex) => {
                                let _TMP_regex_res =
                                  _C_regex.regex.exec(_C_data);
                                if (_TMP_regex_res) {
                                  if (_C_regex.name == "TIME FROM") {
                                    chromiumTimeFrom = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          Time from:{" "}
                                          <strong>{chromiumTimeFrom}</strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "TIME TO") {
                                    chromiumTimeTo = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          Time to:{" "}
                                          <strong>{chromiumTimeTo}</strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "TIME") {
                                    chromiumTime = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          Elapsed time:{" "}
                                          <strong>{chromiumTime} ms</strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "SIZE") {
                                    chromiumSize = parseFloat(
                                      _TMP_regex_res[1]
                                    ).toFixed(1);
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          Downloaded size:{" "}
                                          <strong>{chromiumSize} K</strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "MSG") {
                                    chromiumMsg = _TMP_regex_res[1];
                                  } else if (_C_regex.name == "ERROR") {
                                    chromiumError = _TMP_regex_res[1];
                                  } else if (_C_regex.name == "BYTESIN") {
                                    chromiumBytesIn = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          MBytes IN:{" "}
                                          <strong>
                                            {this.formatMBytes(chromiumBytesIn)}
                                          </strong>
                                        </div>
                                      ),
                                    });
                                  } else if (_C_regex.name == "BYTESOUT") {
                                    chromiumBytesOut = _TMP_regex_res[1];
                                    chromiumInfo.push({
                                      render: (
                                        <div>
                                          MBytes OUT:{" "}
                                          <strong>
                                            {this.formatMBytes(
                                              chromiumBytesOut
                                            )}
                                          </strong>
                                        </div>
                                      ),
                                    });
                                  }
                                  return false;
                                }
                                return true;
                              });
                            });
                            _TMP_split.forEach((str) => {
                              // console.log("word", str.includes("INFO"), str);
                              const errorMatch = str.match(
                                /ERROR:\s*([\s\S]*?)(?=====|$)/
                              );
                              const infoMatch = str.match(/INFO:\s*(.*)/);

                              const error = errorMatch
                                ? errorMatch[1].trim()
                                : "";
                              const info = infoMatch ? infoMatch[1].trim() : "";
                              chromiumError = error;
                              chromiumExtraInfo = info;
                            });
                            //	_TMP_step_result = _TMP_step_result.replace(/^TIME\sFROM:\s(.*)\s\|\sTIME\sTO:\s(.*)\s\|\sTIME:\s(\d*)\s\|\sSIZE:\s([\d\.]*)\s\|\sERROR:\s(.*)/gm, '');
                          }

                          chromiumHar = this.state.content.harid
                            ? this.props.listData.res_id +
                              "." +
                              this.state.content.harid +
                              ".har"
                            : undefined;
                          chromiumLogcat = this.state.content.logcatid
                            ? this.props.listData.res_id +
                              "." +
                              this.state.content.logcatid +
                              ".logcat"
                            : undefined;

                          chromiumJpeg = this.state.content.jpegid
                            ? this.props.listData.res_id +
                              "." +
                              this.state.content.jpegid +
                              ".jpeg"
                            : undefined;

                          chromiumPDF = this.state.content.pdfid
                            ? this.props.listData.res_id +
                              "." +
                              this.state.content.pdfid +
                              ".pdf"
                            : undefined;

                          chromiumVideo =
                            this.state.content.mp4id &&
                            this.getAppContext().momentjs().unix() -
                              this.props.match.params.ts <
                              86400 * 60
                              ? this.props.listData.res_id +
                                "." +
                                this.state.content.mp4id +
                                ".mp4"
                              : undefined;

                          chromiumLmp4 =
                            this.state.content.lmp4id &&
                            this.getAppContext().momentjs().unix() -
                              this.props.match.params.ts <
                              86400 * 60
                              ? this.props.listData.res_id +
                                "." +
                                this.state.content.lmp4id +
                                ".lmp4"
                              : undefined;

                          if (chromiumLmp4) {
                            lmp4URL =
                              this.getAppContext()
                                .getApiStoreService()
                                .getCluster() +
                              this.getAppContext().conf.API_PATH +
                              "/utils/chromescreenstream/" +
                              this.props.match.params.probeuid +
                              "/" +
                              this.props.match.params.measureid +
                              "/" +
                              this.props.listData.bssid.replace(/:/g, "") +
                              "/" +
                              chromiumLmp4 +
                              "?token=" +
                              this.getAppContext().authHandler.getToken();
                          }

                          let objJpeg = undefined;
                          let objVideo = undefined;
                          let objPDF = undefined;

                          // ----------------------------------------- //
                          // Se bssid è NULL non visualizza le immagini.
                          // Nel file Measure_loc la stringa deve essere formattata: "Running on SSID Ethernet-Qv4zp, FREQUENCY 0, BSSID 00:00:00:00:00:00"
                          // diff Transit1_tester.pl Transit1_tester.pl.orig
                          // 85c85
                          // < print $LOGfh "Running on SSID ${I_cssid}, FREQUENCY ${I_chan}, BSSID ${I_bssid}\n";
                          // ---
                          // > print $LOGfh "Running on SSID ${I_cssid}\n";
                          // ----------------------------------------- //

                          if (this.props.listData.bssid) {
                            if (chromiumJpeg) {
                              objJpeg = {
                                url:
                                  this.getAppContext()
                                    .getApiStoreService()
                                    .getCluster() +
                                  this.getAppContext().conf.API_PATH +
                                  "/utils/chromescreenstream/" +
                                  this.props.match.params.probeuid +
                                  "/" +
                                  this.props.match.params.measureid +
                                  "/" +
                                  this.props.listData.bssid.replace(/:/g, "") +
                                  "/" +
                                  chromiumJpeg +
                                  "?token=" +
                                  this.getAppContext().authHandler.getToken(),
                                chromiumJpeg: chromiumJpeg,
                                bssid: this.props.listData.bssid.replace(
                                  /:/g,
                                  ""
                                ),
                                // size: chromiumSize,
                              };
                            }

                            if (chromiumPDF) {
                              objPDF = {
                                url:
                                  this.getAppContext()
                                    .getApiStoreService()
                                    .getCluster() +
                                  this.getAppContext().conf.API_PATH +
                                  "/utils/chromepdfstream/" +
                                  this.props.match.params.probeuid +
                                  "/" +
                                  this.props.match.params.measureid +
                                  "/" +
                                  this.props.listData.bssid.replace(/:/g, "") +
                                  "/" +
                                  chromiumPDF +
                                  "?token=" +
                                  this.getAppContext().authHandler.getToken(),
                                chromiumPDF: chromiumPDF,
                                bssid: this.props.listData.bssid.replace(
                                  /:/g,
                                  ""
                                ),
                                // size: chromiumSize,
                              };
                            }

                            if (chromiumVideo) {
                              objVideo = {
                                url:
                                  this.getAppContext()
                                    .getApiStoreService()
                                    .getCluster() +
                                  this.getAppContext().conf.API_PATH +
                                  "/utils/chromescreenstream/" +
                                  this.props.match.params.probeuid +
                                  "/" +
                                  this.props.match.params.measureid +
                                  "/" +
                                  this.props.listData.bssid.replace(/:/g, "") +
                                  "/" +
                                  chromiumVideo +
                                  "?token=" +
                                  this.getAppContext().authHandler.getToken(),
                                chromiumVideo: chromiumVideo,
                                bssid: this.props.listData.bssid.replace(
                                  /:/g,
                                  ""
                                ),
                                // size: chromiumSize,
                              };
                            }

                            if (lmp4URL != undefined) {
                              objVideo = {
                                url: lmp4URL,
                                chromiumLmp4: chromiumLmp4,
                                bssid: this.props.listData.bssid.replace(
                                  /:/g,
                                  ""
                                ),
                                // size: chromiumSize,
                              };
                            }
                          }

                          return (
                            <div
                              style={{ borderRadius: "3px" }}
                              className="bg-dark text-light"
                            >
                              <div className="p-3">
                                {isChromium ? (
                                  <div>
                                    <Row className="mb-2">
                                      {/* objJpeg.url.error */}
                                      {objJpeg && (
                                        <Col xs={4}>
                                          <div className="overlay">
                                            <img
                                              className="w-100 img-pointer"
                                              alt="sceenshot"
                                              src={objJpeg.url}
                                              onClick={() => {
                                                this.props._overlap_modal_img.open(
                                                  objJpeg
                                                );
                                              }}
                                            />
                                          </div>
                                        </Col>
                                      )}
                                      <Col xs={objJpeg ? 8 : 12}>
                                        <Panel
                                          rounded
                                          className="bg-dark mb-4"
                                          bodyClassName="p-3"
                                        >
                                          <Row className="d-flex">
                                            <Col className="flex-grow-1">
                                              <pre className="body-pre text-light m-0">
                                                {chromiumInfo.map(
                                                  (elem, id) => {
                                                    return (
                                                      <div key={id}>
                                                        {elem.render}
                                                      </div>
                                                    );
                                                  }
                                                )}
                                                {/* <div>
                                                  Time from :{" "}
                                                  <strong>
                                                    {chromiumTimeFrom != ""
                                                      ? chromiumTimeFrom
                                                      : "-"}
                                                  </strong>
                                                </div>
                                                <div>
                                                  Time to :{" "}
                                                  <strong>
                                                    {chromiumTimeTo != ""
                                                      ? chromiumTimeTo
                                                      : "-"}
                                                  </strong>
                                                </div>
                                                <div>
                                                  Elapsed time :{" "}
                                                  <strong>
                                                    {chromiumTime != ""
                                                      ? chromiumTime + " ms"
                                                      : "-"}
                                                  </strong>
                                                </div>
                                                <div>
                                                  Downloaded size :{" "}
                                                  <strong>
                                                    {chromiumSize != ""
                                                      ? chromiumSize + "K"
                                                      : "-"}
                                                  </strong>
                                                </div> */}
                                              </pre>
                                            </Col>

                                            <Col
                                              className="align-self-end"
                                              style={{
                                                maxWidth: "fit-content",
                                              }}
                                            >
                                              {chromiumVideo != undefined ? (
                                                <div className="mb-2">
                                                  <ReactOButton
                                                    className="w-100 text-left"
                                                    onClick={() => {
                                                      this.props._overlap_modal_video.open(
                                                        objVideo
                                                      );
                                                    }}
                                                    icon="file-video"
                                                  >
                                                    Play video
                                                  </ReactOButton>
                                                </div>
                                              ) : null}

                                              {chromiumLmp4 != undefined ? (
                                                <div className="mb-2">
                                                  <ReactOButton
                                                    className="w-100 text-left"
                                                    onClick={() => {
                                                      fetch(lmp4URL)
                                                        .then((response) =>
                                                          response.text()
                                                        )
                                                        .then((url) => {
                                                          let parsedURL =
                                                            "https://" + url;
                                                          let objVideo = {
                                                            url: parsedURL,
                                                            chromiumLmp4:
                                                              chromiumLmp4,
                                                            bssid:
                                                              this.props.listData.bssid.replace(
                                                                /:/g,
                                                                ""
                                                              ),
                                                            // size: chromiumSize,
                                                          };

                                                          this.props._overlap_modal_video.open(
                                                            objVideo
                                                          );
                                                        });
                                                    }}
                                                    icon="file-video"
                                                  >
                                                    Play video
                                                  </ReactOButton>
                                                </div>
                                              ) : null}

                                              {chromiumLogcat != undefined ? (
                                                <div className="mb-2">
                                                  <ReactOButton
                                                    className="w-100 text-left"
                                                    onClick={() => {
                                                      this.props.viewLogcat(
                                                        this.props.listData.bssid.replace(
                                                          /:/g,
                                                          ""
                                                        ),
                                                        chromiumLogcat
                                                      );
                                                    }}
                                                    icon="file-log"
                                                  >
                                                    View .logcat
                                                  </ReactOButton>
                                                </div>
                                              ) : null}
                                              {chromiumHar && (
                                                <div>
                                                  {" "}
                                                  <div className="mb-2">
                                                    <ReactOButton
                                                      className="w-100 text-left"
                                                      onClick={() => {
                                                        this.props.viewHar(
                                                          this.props.listData.bssid.replace(
                                                            /:/g,
                                                            ""
                                                          ),
                                                          chromiumHar
                                                        );
                                                      }}
                                                      icon="file-har"
                                                    >
                                                      View .har
                                                    </ReactOButton>
                                                  </div>
                                                  <div className="mb-2">
                                                    <ReactOButton
                                                      className="w-100 text-left"
                                                      onClick={() => {
                                                        this.props.downloadHar(
                                                          this.props.listData.bssid.replace(
                                                            /:/g,
                                                            ""
                                                          ),
                                                          chromiumHar
                                                        );
                                                      }}
                                                      icon="file-har"
                                                    >
                                                      Download .har
                                                    </ReactOButton>
                                                  </div>
                                                </div>
                                              )}

                                              {chromiumPDF && objPDF && (
                                                <div className="mb-2">
                                                  <ReactOButton
                                                    className="w-100 text-left"
                                                    onClick={() => {
                                                      window.open(objPDF.url);
                                                    }}
                                                    icon="file-pdf1"
                                                  >
                                                    Download PDF
                                                  </ReactOButton>
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </Panel>
                                      </Col>
                                    </Row>
                                    <div>
                                      {chromiumError != "" ? (
                                        <pre className="body-pre text-light">
                                          ERROR: {chromiumError}
                                        </pre>
                                      ) : null}
                                      {chromiumExtraInfo != "" ? (
                                        <pre className="body-pre text-light">
                                          {chromiumExtraInfo}
                                        </pre>
                                      ) : null}
                                      {chromiumMsg != "" ? (
                                        <pre className="body-pre text-light">
                                          {chromiumMsg}
                                        </pre>
                                      ) : null}
                                    </div>
                                  </div>
                                ) : (
                                  <div>
                                    <pre className="body-pre text-light">
                                      {_TMP_step_result ? (
                                        this.props.match.params.measureid
                                          .toLowerCase()
                                          .includes("teams") ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: _TMP_step_result.trim(),
                                            }}
                                          />
                                        ) : (
                                          _TMP_step_result.trim()
                                        )
                                      ) : (
                                        //       ? _TMP_step_result.trim()
                                        "No details available"
                                      )}
                                    </pre>
                                    {!isChromium ? (
                                      <div className="pt-1">
                                        <div className="d-flex justify-content-end">
                                          {chromiumLogcat != undefined ? (
                                            <div className="mb-2 mr-3">
                                              <ReactOButton
                                                className="w-100 text-left"
                                                onClick={() => {
                                                  this.props.viewLogcat(
                                                    this.props.listData.bssid.replace(
                                                      /:/g,
                                                      ""
                                                    ),
                                                    chromiumLogcat
                                                  );
                                                }}
                                                icon="file"
                                              >
                                                View .logcat
                                              </ReactOButton>
                                            </div>
                                          ) : null}

                                          {chromiumVideo != undefined ? (
                                            <div className="mb-2 mr-3">
                                              <ReactOButton
                                                className="w-100 text-left"
                                                onClick={() => {
                                                  this.props._overlap_modal_video.open(
                                                    objVideo
                                                  );
                                                }}
                                                icon="file-video"
                                              >
                                                Play video
                                              </ReactOButton>
                                            </div>
                                          ) : null}

                                          {lmp4URL != undefined ? (
                                            <div className="mb-2 mr-3">
                                              <ReactOButton
                                                className="w-100 text-left"
                                                onClick={() => {
                                                  fetch(lmp4URL)
                                                    .then((response) =>
                                                      response.text()
                                                    )
                                                    .then((url) => {
                                                      let parsedURL =
                                                        "https://" + url;
                                                      let objVideo = {
                                                        url: parsedURL,
                                                        chromiumLmp4:
                                                          "chromiumLmp4",
                                                        bssid:
                                                          this.props.listData.bssid.replace(
                                                            /:/g,
                                                            ""
                                                          ),
                                                        // size: chromiumSize,
                                                      };
                                                      this.props._overlap_modal_video.open(
                                                        objVideo
                                                      );
                                                    });
                                                }}
                                                icon="file-video"
                                              >
                                                Play video
                                              </ReactOButton>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })()}
                      </Collapse>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default contextProvider(withRouter(GridView), {});
